import React from 'react';

const Spinner = ({ size = 'default', className = '', children, spinning = false, tip = '' }) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        default: 'w-6 h-6',
        large: 'w-8 h-8',
    };

    const SpinnerIcon = () => (
        <div
            className={`animate-spin rounded-full border-2 border-gray-300 border-t-blue-600 ${sizeClasses[size]} ${className}`}
        ></div>
    );

    if (children) {
        return (
            <div className="relative">
                {spinning && (
                    <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-10 rounded-lg">
                        <div className="flex flex-col items-center">
                            <SpinnerIcon />
                            {tip && <p className="mt-2 text-sm text-gray-600">{tip}</p>}
                        </div>
                    </div>
                )}
                <div className={spinning ? 'opacity-50 pointer-events-none' : ''}>{children}</div>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center">
            <SpinnerIcon />
            {tip && <p className="ml-2 text-sm text-gray-600">{tip}</p>}
        </div>
    );
};

export default Spinner;
